import { createContext } from 'react';
import { FirebaseUser } from 'models/auth';

export const defaultUser: FirebaseUser = {
  apiKey: '',
  appName: 'Reviewer',
  createdAt: Date.now().toString(), // or use "0" if you prefer
  displayName: '',
  email: '',
  emailVerified: false,
  isAnonymous: true,
  lastLoginAt: Date.now().toString(),
  photoURL: '',
  uid: '',
};

export const UserContext = createContext<{
  user: FirebaseUser;
  setUser: (user: FirebaseUser) => void;
}>({
  user: defaultUser,
  setUser: () => {
    // This is just a placeholder function for the default context value
    // The actual implementation will be provided by a context provider
  },
});
